import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

export const requestUpdateAPIKey = packet => {
  return {
    type: 'REQUEST_UPDATE_API_KEY',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveUpdateAPIKeySuccess = data => ({
  type: 'RECEIVE_UPDATE_API_KEY_SUCCESS',
  data
})

export const receiveUpdateAPIKeyFail = data => ({
  type: 'RECEIVE_UPDATE_API_KEY_FAIL',
  data
})

export const tryToUpdateAPIKey = packet => (dispatch, getState) => {

  dispatch(requestUpdateAPIKey(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/projects/api-key/' + packet.id + '/' + packet.key_id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveUpdateAPIKeySuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveUpdateAPIKeyFail({errors:e, lastSubmit: packet}));
    })
}
